import { z } from "zod";
import { PATTERNS } from "../constants.js";
import { BrandingSchema } from "../webhooks.js";
export const CreateOrganizationInputSchema = z.object({
    slug: z.string().regex(PATTERNS.ORG_SLUG),
    legalName: z.string().min(2).max(200),
    displayName: z.string().min(1).max(120).optional(),
    taxId: z.string().min(8).max(20).nullable().optional(),
    country: z.string().length(2).default("PE"),
    timezone: z.string().min(1).default("America/Lima"),
    branding: BrandingSchema.default({}),
});
export const UpdateOrganizationInputSchema = CreateOrganizationInputSchema.partial().omit({ slug: true });
export const ListOrganizationsQuerySchema = z.object({
    q: z.string().max(120).optional(),
    status: z.enum(["active", "suspended", "closed"]).optional(),
    moduleCode: z.string().regex(PATTERNS.MODULE_CODE).optional(),
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(25),
});
/** Respuesta paginada genérica por cursor. */
export const PageSchema = (item) => z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=organizations.js.map